var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"one"}},[_c('header',{staticClass:"major"},[_c('h1',[_vm._v(_vm._s(_vm.headline))])]),_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }